import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

import { AdalService } from '../service';
import {AdUser, GridSettings, GridState, User} from '../shared/';
import { Constants } from '../shared/constants';
import { LoaderService } from '../core/loader/loader.service';
import { NotificationService } from '../service/notification.service';
import { NotificationType } from '../shared/enum/notification.enum';


@Injectable()
export class UserApi {
	private token = localStorage.getItem('token');
	private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });
	private options = { headers: this.headers };
	private url = Constants.devServerEndpoint + 'api/';
	private currentUser: User;

	constructor(
		private httpClient: HttpClient,
		private permissionsService: NgxPermissionsService,
		private loaderService: LoaderService,
		private notificationService: NotificationService,
		private adalService?: AdalService,
		private router?: Router,
	) { }

	public getUsers(): Observable<User[]> {
		return this.httpClient.get(this.url + '/users/getusers', this.options)
			.pipe(
				map((response: any) => response.json() as any)
			);
	}

	public getLogonUser(adUser: AdUser): Observable<User> {
		this.loaderService.show();
		return this.httpClient.post(this.url + 'users/signeduserdata', JSON.stringify(adUser), this.options)
			.pipe(map((response: any) => response),
				tap((data: User) => {
					if (data) {
						this.currentUser = data[0];
						this.permissionsService.loadPermissions([data[0].userRoleKey]);
						this.loaderService.hide();
					}
				}),
				catchError(
					(error) => observableThrowError(this.errorHandler(error))
				)
			);
	}

	public postUserNewData(userData) {
		this.httpClient.post(this.url + '/users/userupdate', JSON.stringify(userData), this.options).subscribe(i => i);
	}

	/*getGroupMemberOf(): Observable<any> {
       return this.http.get('https://graph.microsoft.com/v1.0/users/Bahodir.Karshibayev@klinegroup.com', this.options)
            .map(res => res.json)
            .catch((error) => Observable.throw(this.errorHandler(error)));
    }*/

	public get logonUser() {
		if (!this.currentUser) {
			this.router.navigate(['']);
		} else {
			return this.currentUser;
		}
	}

	public getGridSettings(data: GridSettings): Observable<GridSettings> {
		return this.httpClient
			.post<GridSettings>(
			this.url + `users/getGridSettings`, data,
			{ headers: this.headers }
			)
			.pipe(
			map(item => {
				return item[0];
			})
			);
	}

	public setGridSettings(data: GridSettings): Observable<boolean> {
		return this.httpClient
			.post<any>(
			this.url + 'users/setGridSettings', data,
			{ headers: this.headers }
			);
	}

	public resetDataGridStateToDefault(gridName: string, pageName: string, ownedByUserId: number) {
		const data = {
			GridName: gridName,
			OwnedByUserId: ownedByUserId,
			PageName: pageName,
			StateName: null,
			State: null
		};
		return this.httpClient.post(this.url + 'users/resetDataGridStateToDefault', data,
			{ headers: this.headers });
	}

	public setGridState(data: GridState): Observable<boolean> {
		return this.httpClient
			.post<any>(
			this.url + 'users/setGridState', data,
			{ headers: this.headers }
			);
	}

	public getGridState(data: GridState): Observable<GridState> {
		return this.httpClient
			.post<GridSettings>(
			this.url + `users/getGridState`, data,
			{ headers: this.headers }
			).pipe(
			map(item => {
				return item[0];
			})
			);
	}

	private errorHandler(error: any): void {
		this.notificationService.show('Something went wrong. Please, Logout and Login again', NotificationType.Error);
		window.sessionStorage.clear();

		// setTimeout(()=>{
		//     window.location.reload();
		//   }, 2000);
		console.log(error);
	}
}
